export function Show({ children, when }: { when: boolean; children: React.ReactNode }) {
  if (!when) return null;
  return children;
}
